import { makeStyles, mergeClasses } from "@fluentui/react-components";
import {
  CheckmarkCircleRegular,
  ErrorCircleRegular,
  WarningRegular,
} from "@fluentui/react-icons";
import HOPEnum from "../../../enum/HOPEnum";

export const StatusIconSelector: React.FunctionComponent<
  IStatusIconSelectorProps
> = (props) => {
  const classes = useStyles();

  const statusIcon = (() => {
    switch (props.status) {
      case HOPEnum.HOPDataStatus.Poor:
        return (
          <ErrorCircleRegular
            className={mergeClasses(
              props.class ? props.class : classes.icon,
              classes.errorIcon
            )}
            data-testid="airport-otp-poor"
          />
        );
      case HOPEnum.HOPDataStatus.Moderate:
        return (
          <WarningRegular
            className={mergeClasses(
              props.class ? props.class : classes.icon,
              classes.warningIcon
            )}
            data-testid="airport-otp-moderate"
          />
        );
      case HOPEnum.HOPDataStatus.Good:
        return (
          <CheckmarkCircleRegular
            className={mergeClasses(
              props.class ? props.class : classes.icon,
              classes.goodIcon
            )}
            data-testid="airport-otp-good"
          />
        );
      default:
        return null;
    }
  })();

  return <>{statusIcon}</>;
};

export interface IStatusIconSelectorProps {
  status: string;
  class?: any;
}

const useStyles = makeStyles({
  icon: {
    fontSize: "18px",
    strokeWidth: "0.5px",
    verticalAlign: "bottom",
    paddingRight: "4px",
  },
  goodIcon: {
    color: "#569643",
    stroke: "#569643",
  },
  errorIcon: {
    color: "#B2271F",
    stroke: "#B2271F",
  },
  warningIcon: {
    color: "#FA6400",
    stroke: "#FA6400",
  },
});
